//
//
//

export default {
  name: 'empty',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    message: String
  },
  data: function data() {
    return {
      text: ''
    };
  },
  created: function created() {
    this.text = this.message || "\u70B9\u51FB\u8FDB\u884C".concat(this.value.widget, "\u914D\u7F6E");
  }
};